import { AnimalData } from '@/components/PetSitter/AddAnimal/AnimalForm'
import { CreateAnimal } from '@/modules/User/apiTypes/ContinueRegister'
import { AnimalSpecies } from '@/dataV3/Animal/AnimalSpecies'
import { Gender } from '@/dataV3/Common/Gender'

export const buildAnimalRequestBody = (values: AnimalData): CreateAnimal.Body => ({
  speciesSlug: values.selectedRadio || AnimalSpecies.dog,
  displayName: values.displayName,
  breedSlug: values.breedSlug,
  sizeSlug: values.sizeSlug,
  birthDate: new Date(values.birthDate).toISOString(),
  gender: (values.gender as Gender) || Gender.female,
  mainPicture: values.mainPicture || '',
  animalPictures: values.animalPictures,
  description: values.description,
  animalOptions: {
    niceWithChildren: values.affinities?.niceWithChildren || false,
    niceWithDogs: values.affinities?.niceWithDogs || false,
    niceWithCats: values.affinities?.niceWithCats || false,
    entrustFewHours: values.times?.entrustFewHours || false,
    entrustDayNight: values.times?.entrustDayNight || false,
    entrustWeekendHoliday: values.times?.entrustWeekendHoliday || false,
    availabilityWeekDay: values.availability?.availabilityWeekDay || false,
    availabilityWeekNight: values.availability?.availabilityWeekNight || false,
    availabilityWeekend: values.availability?.availabilityWeekend || false,
    needTrips: values.needs?.needTrips || false,
    needExercise: values.needs?.needExercise || false,
    needPlay: values.needs?.needPlay || false,
    needKeep: values.needs?.needKeep || false,
    needTakeCare: values.needs?.needTakeCare || false,
    needLove: values.needs?.needLove || false,
    sterilized: values.sterilized || false,
    displayToBorrowers: values.showVolunteer || false,
  },
})
